import invariant from "fbjs/lib/invariant";
export default (value, name) =>
  invariant(value !== undefined, `${name} should be defined!`) || true;
